import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';
import { workspaceTabsFetchedThunk } from 'state/workspaces/workspace.thunks';

export function fetchPostTradeWorkspaceTabsEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'postTrade'),
      mergeMap(({ tabFetchRequestId }) =>
        tabsApiConnector(httpClient, 'postTrade')
          .getAllTabDescriptions()
          .pipe(
            map(({ tabs, activeTabId }) => {
              const actualActiveTabId: string | undefined = activeTabId ?? tabs[0]?.id ?? undefined;
              return workspaceTabsFetchedThunk(tabs, actualActiveTabId, 'postTrade', tabFetchRequestId);
            }),
            catchError((_: Error) => {
              return of(workspaceTabsFetchFailed('postTrade', tabFetchRequestId));
            }),
          ),
      ),
    );
}
